<template>
  <div class="container print-semiology">
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="errors.length > 0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div v-show="errors.length == 0">
        <div
          v-if="!certificate"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end"
        >
          <v-btn v-if="!loading" class="btn-print" v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
        <table>
          <thead>
            <tr>
              <td>
                <div class="header-space">
                  <div v-if="resident.id" class="row">
                    <div
                      class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 pt-0 pb-0"
                    >
                      <img
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div
                      class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 d-flex align-items-center pt-0 pb-0"
                    >
                      <img
                        v-if="resident.photo_url"
                        class="resident_photo_url"
                        :src="resident.photo_url"
                      />
                      <img
                        v-if="!resident.photo_url"
                        class="resident_photo_url"
                        :src="require('../../../assets/user.png')"
                      />
                      <div class="ml-5">
                        <h6 class="mb-0">
                          {{ resident.name }}
                        </h6>
                        <h6 class="mb-0 worksansr upper-text">
                          Data de nascimento:
                          {{ formatDate(resident.date_of_birth, false) }}
                          -
                          {{ getAge(resident.date_of_birth) }}
                          anos
                        </h6>
                        <h6 class="mb-0 worksansr upper-text">
                          Data de admissão:
                          {{ formatDate(resident.date_of_reception, false) }}
                        </h6>
                        <h6
                          class="mb-0 worksansr upper-text"
                          v-if="resident.bed_id"
                        >
                          Leito Nº: {{ resident.bed_number }}, Andar:
                          {{ resident.bed_walk }}, ALA/Setor:
                          {{ resident.bed_ward_or_sector }}, Quarto:
                          {{ resident.bed_bedroom }}
                        </h6>
                      </div>
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end pt-0 pb-0"
                    >
                      <img class="logo" :src="logo" width="180" />
                    </div>
                    <div
                      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex flex-column align-items-center justify-content-end pt-0 pb-0"
                    >
                      <h5 class="upper-text mb-0">
                        FORMULÁRIO: {{ semiology_form.name }}
                      </h5>
                      <h6 class="upper-text worksansr text-fourteen m-0"></h6>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content">
                  DESCRIÇÃO: {{ semiology_form.description }}
                  <div v-for="category in categories" :key="category.id">
                    <h5 class="m-0 upper-text d-flex align-items-center">
                      CATEGORIA:
                      {{ category.name }}
                      <span class="ml-2 worksansr text-thirteen"
                        >({{ category.questions.length }}
                        {{
                          category.questions.length > 1
                            ? "perguntas"
                            : "pergunta"
                        }})</span
                      >
                    </h5>
                    <div
                      v-for="(question, question_index) in category.questions"
                      :key="question.id"
                      class="content-question row m-0 border-bottom"
                    >
                      <h6
                        class="col-md-6 pt-0 pb-0 m-0 d-flex align-items-center"
                      >
                        {{ question_index + 1 }}. {{ question.statement }}
                        {{ question.mandatory == 1 ? "(Obrigatório)" : "" }}
                      </h6>
                      <div class="col-md-6 pt-0 pb-0 m-0">
                        <Open
                          v-if="
                            question.semiology_form_question_type_value ==
                            'OPEN'
                          "
                          :question="question"
                          :category_id="category.id"
                        />
                        <Rating
                          v-if="
                            question.semiology_form_question_type_value ==
                            'RATING'
                          "
                          :category_id="category.id"
                          :question="question"
                        />
                        <SingleChoice
                          v-if="
                            question.semiology_form_question_type_value ==
                            'SINGLE_CHOICE'
                          "
                          :category_id="category.id"
                          :question="question"
                        />
                        <MultipleChoice
                          v-if="
                            question.semiology_form_question_type_value ==
                            'MULTIPLE_CHOICE'
                          "
                          :category_id="category.id"
                          :question="question"
                        />
                        <Dichotomous
                          v-if="
                            question.semiology_form_question_type_value ==
                            'DICHOTOMOUS'
                          "
                          :category_id="category.id"
                          :question="question"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="footer text-center" v-if="!certificate">
                    <hr class="mb-1 border-black" />
                    <h6 class="mb-0 worksansr">
                      (Assinatura eletrônica)
                      <strong>
                        {{
                          professionalClassCouncilValue({
                            id: semiology_form_question_answer.user_professional_class_council_id,
                            name: semiology_form_question_answer.user_name,
                            profile:
                              semiology_form_question_answer.user_profile_name,
                            cpf: semiology_form_question_answer.user_cpf,
                            office: semiology_form_question_answer.user_office,
                            value:
                              semiology_form_question_answer.user_professional_class_council_value,
                          })
                        }}
                        - Aberto no dia
                        {{
                          formatDate(semiology_form_question_answer.created_at)
                        }}
                        <span v-if="semiology_form_question_answer.updated_at"
                          >, finalizado no dia
                          {{
                            formatDate(
                              semiology_form_question_answer.updated_at
                            )
                          }}
                        </span>
                      </strong>
                    </h6>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div class="footer-space">&nbsp;</div>
              </td>
            </tr>
          </tfoot>
        </table>
        <div
          v-if="!certificate"
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end"
        >
          <v-btn v-if="!loading" class="btn-print" v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import Open from "./Print/Open";
import Rating from "./Print/Rating";
import SingleChoice from "./Print/SingleChoice";
import MultipleChoice from "./Print/MultipleChoice";
import Dichotomous from "./Print/Dichotomous";

import api from "../../../services/api";

import { formatDate, professionalClassCouncilValue } from "../../../lib/format";

import routes from "../../../routes";

import { userData } from "../../../lib/functions";

import { getAge } from "../../../lib/getAgeByDate";

export default {
  name: "AnsweredFormPrint",
  components: {
    ErrorsMessages,
    Open,
    Rating,
    SingleChoice,
    MultipleChoice,
    Dichotomous,
  },
  data() {
    return {
      resident: {},
      semiology_form: {},
      resident_id: "",
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: false,
      categories: [],
      semiology_form_question_answer: {},
      errors: [],
      certificate: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    formatDate,
    professionalClassCouncilValue,
    async retrieve() {
      const {
        resident_id,
        semiology_form_id,
        semiology_form_question_answer_id,
      } = routes.history.current.params;

      const { certificate } = routes.history.current.query;

      const { user, logo } = userData();

      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      this.resident_id = resident_id;
      this.semiology_form_id = semiology_form_id;
      this.semiology_form_question_answer_id =
        semiology_form_question_answer_id;

      if (certificate) {
        this.certificate = certificate;
      }

      await this.get();
    },
    async get() {
      try {
        this.loading = true;

        let {
          resident_id,
          semiology_form_id,
          semiology_form_question_answer_id,
        } = this;

        let params = {
          resident_id,
          semiology_form_id,
          semiology_form_question_answer_id,
        };

        let response = await api.get(
          "/rest-home/answer-semiology/answered-form-print",
          {
            params,
          }
        );

        let {
          error,
          errors,
          resident,
          semiology_form,
          categories,
          semiology_form_question_answer,
        } = response.data;
        if (!error) {
          this.resident = resident;
          this.semiology_form = semiology_form;
          this.categories = categories;
          this.semiology_form_question_answer = semiology_form_question_answer;
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    printOut: () => window.print(),
  },
};
</script>

<style>
.print-semiology .header,
.print-semiology .header-space {
  height: 150px;
}

.print-semiology .footer,
.print-semiology .footer-space {
  height: 50px;
}

.print-semiology .header {
  position: fixed;
  top: 0;
}

.print-semiology .logo {
  height: 50px;
  object-fit: contain;
}

.print-semiology .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.print-semiology .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  object-fit: cover;
}

.print-semiology table,
.print-semiology td,
.print-semiology th,
.print-semiology tfoot {
  width: 100% !important;
  padding: 5px;
  cursor: auto !important;
}

.print-semiology .signature {
  width: 100%;
  margin-top: 12px;
  border-top: solid 1px #000;
}

.print-semiology th {
  background-color: #f5f5f5;
}

.print-semiology tr span {
  font-size: 15px;
}

.print-semiology caption {
  font-size: x-large;
}

@media print {
  .print-semiology table {
    width: 100% !important;
    border: none !important;
    margin-top: 10px !important;
  }

  .print-semiology .content {
    page-break-inside: avoid !important;
  }

  .print-semiology .content .content-question {
    page-break-inside: avoid !important;
  }

  .print-semiology .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  * {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
  }

  body {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.4em !important;
  }

  .print-semiology button {
    display: none;
  }
}
</style>
